import React, { useEffect, useState } from "react";
import ApiService from '../Components/apiService';
import { BASE_URL,DateFormat,DateTimeFormat } from '../Components/Constant';
import { Table, Button, Typography, Checkbox,Row,Col,Tooltip,Popconfirm,Spin,message } from 'antd';
import { CopyOutlined, DeleteOutlined,EditOutlined, TrophyFilled} from '@ant-design/icons';
import {convertDateToUserTimezone} from '../Components/Utility';

import LayoutEditor from "./LayoutEditor";
import dayjs from 'dayjs';
import { useSelector } from "react-redux";


const { Title } = Typography;

const CreateLayout = ({ object }) => {
    const [layouts, setLayouts] = useState([]);
    const [showLayoutEditor, setShowLayoutEditor] = useState(false);
    const [fields, setFields] = useState({});
    const [selectedLayout, setSelectedLayout] = useState(null);
    const [isCloning, setIsCloning] = useState(false); // State for cloning
    const [loading,setLoading]=useState(true);
    const security = useSelector((state) => state.data.items[0]);
    const [pageSize, setPageSize] = useState(10);


    // Fetch all layouts and fields for the given object
    const getAllLayouts = async () => {
        try {
            setLoading(true);
            const apiService = new ApiService(`${BASE_URL}/get_by_objectName/${object.name}`, {}, 'GET');
            const responseData = await apiService.makeCall();
            
            setLayouts(responseData);
        } catch (error) {
            console.error('Error fetching layouts or fields:', error);
        }finally{
            setLoading(false);
        }
    };


    const getFields=async()=>{
        try{
            const fieldApiService = new ApiService(`${BASE_URL}/mt_fields/object/${object.name}`, {}, 'GET');
            const fieldResponse = await fieldApiService.makeCall();
            const filteredFields =fieldResponse.filter(
                field => !['recordCount', 'CreatedBy', 'LastModifiedBy'].includes(field.name)
              );
            setFields(filteredFields);
        }catch(error){

        }

    }
    useEffect(() => {
        getAllLayouts();
        getFields();
    }, [object]);

    // Handle editing a layout
    const handleEditLayout = (layout,clone=false) => {
        if(security?.system_settings?.layouts.edit===false){
            message.error('You dont have permission to edit ');
            return;
          }
        setSelectedLayout(layout);
        setIsCloning(clone); 
        setShowLayoutEditor(true);
    };


    const deleteLayout = async (layout) => {
        try{
            const apiService = new ApiService(`${BASE_URL}/delete_layout/${layout._id}`, {}, 'DELETE');
            await apiService.makeCall();
            getAllLayouts();
        }
        catch(error){
            console.error('Error deleting layout:', error);
        }
    }

    const columns = [
        {
            title: "Layout Name",
            dataIndex: "layout_name",
            key: "layout_name",
            sorter: (a, b) => a.layout_name.localeCompare(b.layout_name),
            render: (text, record) => (
                <a onClick={() => handleEditLayout(record)}>{text}</a>
            ), // Make layout name clickable
        },
        {
            title: "Active",
            dataIndex: "active",
            key: "active",
            render: (active) => <Checkbox checked={active} disabled />,
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            key: "created_at",
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            render: (text) => (
                text && dayjs(text).isValid()
                  ? convertDateToUserTimezone(text, DateTimeFormat)
                  : ''
              ),
        },

    ];

    columns.push({
        title: 'Action',
        key: 'operation',
        render: (_, layout) => (
          <>
           <Tooltip title="Edit">
            <EditOutlined
                onClick={() => handleEditLayout(layout,false)}
                style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
            />
            </Tooltip>                 
            
            <Tooltip title="Clone">
              <CopyOutlined
                onClick={() => handleEditLayout(layout,true)}
                style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
              />
            </Tooltip>
          </>
        ),
      });

    return (
        <div>
            {!showLayoutEditor ? (
                <div>
                <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
                    <Col>
                        <Title level={4} >Layouts</Title>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            onClick={() => {
                                if(security?.system_settings?.layouts.create===false){
                                    message.error('You dont have permission to create ');
                                    return;
                                  }
                                setSelectedLayout(null);
                                setIsCloning(false); 
                                setShowLayoutEditor(true);
                            }}
                        >
                            Create Layout
                        </Button>
                    </Col>
                </Row>

                    {/* Render layouts in a table */}
                    <Spin spinning={loading} size="size">
                    <Table
                        dataSource={layouts}
                        columns={columns}
                        rowKey="_id"
                        scroll={{ x: 'max-content', y: 550 }}
                        pagination={{
                            pageSize: pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            onChange: (page, pageSize) => {
                                setPageSize(pageSize);
                            },              
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        }}
                    />
                    </Spin>
                </div>
            ) : (
                <LayoutEditor
                    object={object.name}
                    objId={object._id}
                    fields={fields}
                    Editinglayout={selectedLayout}
                    getAllLayouts={getAllLayouts}
                    isCloning={isCloning}
                    onBack={() => setShowLayoutEditor(false)}
                />
            )}
        </div>
    );
};

export default CreateLayout;